// extracted by mini-css-extract-plugin
export default {"template-card":"styles_template-card__ZiBO6","template-description":"styles_template-description__A7kiT"};